export const ShopInStoreSVG = (props) => (
  <svg
    height={16}
    viewBox="0 0 18 16"
    width={18}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="#010202">
      <path d="M16.912 6.021H1.072" strokeLinecap="round" />
      <path d="M16.912 6.021l-3.731-4.95H4.797l-3.726 4.95v8.91h15.84z" />
    </g>
  </svg>
);
